import { PointerEventHandler, useState } from 'react';
import { HoverStateProps, StateSettings } from '../types';
import { detectStateClassName } from '../lib';

export function useHover({
  hasHover = true,
  shouldForceHovered = false,
  hoverClassName,
}: HoverStateProps): StateSettings {
  const [state, setState] = useState(false);

  const className = detectStateClassName(
    hasHover,
    shouldForceHovered,
    state,
    hoverClassName
  );

  const handlePointerEnter: PointerEventHandler = (event) => {
    /**
     * 💬 Игнорируем тач-эвенты
     */
    if (event.pointerType === 'touch') {
      return;
    }

    setState(true);
  };

  const handlePointerLeave: PointerEventHandler = () => {
    setState(false);
  };

  return {
    className,
    handlers: {
      onPointerEnter: hasHover ? handlePointerEnter : undefined,
      onPointerLeave: hasHover ? handlePointerLeave : undefined,
    },
  };
}
